// Ownezzy Delivery Policy: how website plans bought on ownezzy.com are delivered (online, nothing is shipped). Stores
// built on Ownezzy have their own delivery terms, set by each Seller.
// Each section: { heading, text?: [paragraphs], list?: [items] }. Have changes reviewed by a lawyer before publishing.
// C: Ownezzy's contact (useOwnezzyContact in ./contact.js)
export const deliveryFor = (C) => ({
  title: 'Delivery Policy',
  lastUpdated: '3 November 2026',
  intro: [
    `Ownezzy (operated by ${C.operator}, sole proprietor, India) sells website software and hosting plans. They are digital services delivered online: no physical product is shipped, and there are no shipping charges.`,
  ],
  sections: [
    {
      heading: '1. When you get your website',
      list: [
        'Free trial and paid plans: your store is created and its login details are shown on screen and sent to your email right after sign-up or payment, usually within a few minutes.',
        'Payments by manual UPI (when offered) are confirmed by our team, normally within a few working hours, after which the website is created and the login details are emailed.',
        'Renewals and add-ons apply to your account as soon as the payment is confirmed.',
        'A custom domain name may take up to 24–48 hours to start working everywhere after it is registered or connected, because of how the internet updates domain records.',
      ],
    },
    {
      heading: '2. Where it is delivered',
      text: ['Everything is delivered online, to customers in India and abroad: the website at its web address, the admin panel at admin.ownezzy.com, and login details to the email address you gave at sign-up.'],
    },
    {
      heading: '3. If you did not receive it',
      text: [`If you paid but did not receive your login details, check your spam folder, then contact us at ${C.email} or WhatsApp ${C.whatsapp} with the payment reference. We will activate your website or refund you as described in our Cancellation & Refund Policy.`],
    },
    {
      heading: '4. Products sold on stores built with Ownezzy',
      text: ['Products and services sold on a Seller\'s store are shipped or delivered by that Seller, under the Seller\'s own delivery terms. Ownezzy does not ship or deliver them (see our Terms of Service).'],
    },
  ],
});
